import React, {Component} from 'react'
import { GlgBasicSelect } from 'SharedComponents'
import PropTypes from 'prop-types'
import { Col } from 'react-flexbox-grid'

export class StateSelectComponent extends Component {
  constructor(props){
    super(props)
  }

  render(){
    return (
      <Col xs={12} md={8}>
        <GlgBasicSelect
          items={this.props.sortedStates.map( x => ({label: x, value: x, disabled: x.startsWith('--')}))}
          value={this.props.answer ? this.props.answer : ''}
          onChange={(val) => this.props.onChange(this.props.field.id, this.props.field.category, this.props.field.name, val)}
          selectClass="form-control"
          prompt={ !window.I18n ? '' : window.I18n.t('members_page.components.add_golfers_manually.custom_fields_components.state_select_component.select_state') } />
      </Col>
    )
  }
}

StateSelectComponent.propTypes = {
  field: PropTypes.object.isRequired,
  answer: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  sortedStates: PropTypes.array.isRequired,
}

export default StateSelectComponent
